var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app',{scopedSlots:_vm._u([{key:"languageSelection",fn:function(){return [_c('language-selection')]},proxy:true},{key:"content",fn:function(){return [_c('home')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }